// extracted by mini-css-extract-plugin
export default {"wrapperContent":"UserOverview_wrapperContent__3AF5y","tableWrapper":"UserOverview_tableWrapper__VKEZu"};